import React, { useEffect, useRef, useState } from 'react'
import className from 'classnames'
import InputMask from "react-input-mask";
import Button from '../Button/Button'
import Datepicker from '../Datepicker/Datepicker'
import { format, isValid, subDays } from 'date-fns'
import { getMaxDate, getMinDate } from '../DateTime/helper'
import { months, validDateRegex, withInRangeSet, getMaskValue } from '../Datepicker/helpers'
import ButtonGroup from '../Button/ButtonGroup/ButtonGroup'
import FieldLabel from '../FieldLabel/FieldLabel'
import ValidationMessage from '../ValidationMessage/ValidationMessage';
// import './DateRangePicker.css'

export const DateRangePickerV2: any = (props: any) => {
  const {
    cancelCtaTestId,
    doneCtaTestId,
    onCancel,
    onDone,
    inputMaskTestId,
    inputMaskDisabled,
    placeholder,
    testId,
    minDate,
    maxDate,
    minStartDate,
    maxEndDate,
    startDate,
    endDate,
    classname,
    onChangeCb,
    onSave,
    dateChangeChildren,
    onResetCb,
    customFilterDates,
    withFooter = true,
    withFilters = true,
    ...rest
  }: any = props
  const getSelectedCalenderFilter = (sDate, eDate) => {
    let filterLabel: any = 'Custom Date'
    if (format(eDate, 'MM-dd-yyyy') !== format(new Date(), 'MM-dd-yyyy')) {
      filterLabel = 'Custom Date'
    } else {
      if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 1)), 'MM-dd-yyyy')) filterLabel = 'Last 1 day';
      else if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 6)), 'MM-dd-yyyy')) filterLabel = 'Last 7 days';
      else if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 13)), 'MM-dd-yyyy')) filterLabel = 'Last 14 days';
      else if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), 29)), 'MM-dd-yyyy')) filterLabel = 'Last 30 days';
      else {
        if (customFilterDates?.length > 0) {
          customFilterDates.map((el) => {
            if (format(sDate, 'MM-dd-yyyy') === format(new Date(subDays(new Date(), (el - 1))), 'MM-dd-yyyy')) {
              filterLabel = `Last ${el} days`
            }
          })
        }
      }
    }
    return filterLabel
  }
  const [currentCalenderActive, setcurrentCalenderActive] = useState('from')
  const [calenderStartDate, setCalenderStartDate] = useState(new Date(new Date(startDate).setHours(0, 0, 0, 0)))
  const [calenderEndDate, setCalenderEndDate] = useState(new Date(new Date(endDate).setHours(23, 59, 59, 59)))
  const [startDateInputMask, setStartDateInputMask] = useState(format(new Date(startDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
  const [endDateInputMask, setEndDateInputMask] = useState(format(new Date(endDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
  const [selectedCalenderFilter, setSelectedCalenderFilter] = useState(getSelectedCalenderFilter(startDate, endDate))
  const [rangeHasErrorObject, setRangeHasErrorObject] = useState({
    has_error: false,
    error_message: ''
  })

  const calenderRangeStart = useRef(null);
  const calenderRangeEnd = useRef(null);


  const onStartDateInputChangeHandler = (event: any) => {
    if (event.target.value) {
      let dateValue = event.target.value;
      if (dateValue === "mm-dd-yyyy") {
        if (dateValue.replace(/y|m|d/g, '').match(/^[\d-/]+$/)) {
          setRangeHasErrorObject({
            has_error: true,
            error_message: 'Please enter/select end date'
          })
          setStartDateInputMask(dateValue)
        }
      } else if (((dateValue.match(validDateRegex) !== null)) || dateValue === '') {
        const gmtFormat: any = new Date(dateValue) || dateValue
        let updatedDateValue: any = new Date(gmtFormat).getTime() ? format(gmtFormat, 'MM-dd-yyyy') : gmtFormat
        // onChange(updatedDateValue)
        if (rangeHasErrorObject.has_error && endDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
        // hasErrorCB && hasErrorCB(false)
        setStartDateInputMask(dateValue)
        setCalenderStartDate(gmtFormat)
        if (gmtFormat.getTime() > calenderEndDate.getTime()) {
          setCalenderEndDate(gmtFormat)
          setEndDateInputMask(dateValue)
        }
        onChangeCb && onChangeCb([
          {
            startDate: gmtFormat,
            endDate: calenderEndDate,
          }
        ])
        setSelectedCalenderFilter(getSelectedCalenderFilter(gmtFormat, calenderEndDate))
        calenderRangeStart?.current?.setSelected(gmtFormat, event)
        calenderRangeStart?.current?.setPreSelection(gmtFormat)
        if (calenderRangeStart?.current?.calenderView !== "date") calenderRangeStart?.current?.setCalenderView("date")
      } else {
        if (!rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: true, error_message: 'Please enter valid date' })
        // hasErrorCB && hasErrorCB(true)
        setStartDateInputMask(dateValue)
      }
    }
  }

  const onEndDateInputChangeHandler = (event: any) => {
    if (event.target.value) {
      let dateValue = event.target.value;
      if (dateValue === "mm-dd-yyyy") {
        if (dateValue.replace(/y|m|d/g, '').match(/^[\d-/]+$/)) {
          setRangeHasErrorObject({
            has_error: true,
            error_message: 'Please enter/select end date'
          })
          setEndDateInputMask(dateValue)
        }
      } else if (((dateValue.match(validDateRegex) !== null)) || dateValue === '') {
        const gmtFormat: any = new Date(dateValue) || dateValue
        if (gmtFormat.getTime() < calenderStartDate.getTime()) {
          setEndDateInputMask(dateValue)
          setRangeHasErrorObject({
            has_error: true,
            error_message: 'End date cannot be less than start date'
          })
        } else {
          let updatedDateValue: any = new Date(gmtFormat).getTime() ? format(gmtFormat, 'MM-dd-yyyy') : gmtFormat
          // onChange(updatedDateValue)
          if (rangeHasErrorObject.has_error && startDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
          // hasErrorCB && hasErrorCB(false)
          setEndDateInputMask(dateValue)
          setCalenderEndDate(gmtFormat)
          onChangeCb && onChangeCb([
            {
              startDate: calenderStartDate,
              endDate: gmtFormat,
            }
          ])
          setSelectedCalenderFilter(getSelectedCalenderFilter(calenderStartDate, gmtFormat))
          calenderRangeEnd?.current?.setSelected(gmtFormat, event)
          calenderRangeEnd?.current?.setPreSelection(gmtFormat)
        }
        if (calenderRangeEnd?.current?.calenderView !== "date") calenderRangeEnd?.current?.setCalenderView("date")
      } else {
        if (!rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: true, error_message: 'Please enter valid date' })
        // hasErrorCB && hasErrorCB(true)
        setEndDateInputMask(dateValue)
      }
    }
  }

  const onStartDateCalenderChangeHandler = (date) => {
    if (calenderEndDate.getTime() < new Date(date.split(' ').join('-')).getTime()) {
      setCalenderEndDate(new Date(date.split(' ').join('-')))
      setEndDateInputMask(date.split(' ').join('-'))
      setSelectedCalenderFilter('Custom Date')
    }
    setCalenderStartDate(new Date(date.split(' ').join('-')))
    setStartDateInputMask(date.split(' ').join('-'))
    onChangeCb && onChangeCb([
      {
        startDate: new Date(date.split(' ').join('-')),
        endDate: calenderEndDate,
      }
    ])
    if (rangeHasErrorObject.has_error && endDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
    setSelectedCalenderFilter(getSelectedCalenderFilter(new Date(date.split(' ').join('-')), calenderEndDate))
    calenderRangeStart?.current?.calenderViewType === "date" && setcurrentCalenderActive('to')
  }

  const onEndDateCalenderChangeHandler = (date) => {
    setCalenderEndDate(new Date(date.split(' ').join('-')))
    setEndDateInputMask(date.split(' ').join('-'))
    onChangeCb && onChangeCb([
      {
        startDate: calenderStartDate,
        endDate: new Date(date.split(' ').join('-')),
      }
    ])
    if (rangeHasErrorObject.has_error && startDateInputMask.match(validDateRegex) !== null) setRangeHasErrorObject({ has_error: false, error_message: '' })
    setSelectedCalenderFilter(getSelectedCalenderFilter(calenderStartDate, new Date(date.split(' ').join('-'))))
  }

  const onDoneClickHandler = () => {
    onChangeCb && onChangeCb([
      {
        startDate: calenderStartDate,
        endDate: calenderEndDate
      }
    ])
    if (onDone) onDone([
      {
        startDate: calenderStartDate,
        endDate: calenderEndDate,
        key: 'selection',
        type: 'initial'
      }
    ])
    if (onSave) onSave([{
      startDate: calenderStartDate,
      endDate: calenderEndDate,
    }])
    if (rest.closeModal) {
      rest.closeModal()
    }
  }

  const onCancelClickHandler = () => {
    if (onCancel) onCancel()
    if (rest.closeModal) {
      rest.closeModal()
    }
  }

  const onResetClickHandler = (e: any) => {
    if (dateChangeChildren) {
      if (onResetCb) onResetCb()
      if (rest.closeModal) rest.closeModal()
    } else {
      setCalenderStartDate(startDate)
      setCalenderEndDate(endDate)
      setStartDateInputMask(format(new Date(startDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
      setEndDateInputMask(format(new Date(endDate), 'MM-dd-yyyy') || format(new Date(), 'MM-dd-yyyy'))
      onChangeCb && onChangeCb([
        {
          startDate: startDate,
          endDate: endDate
        }
      ])
      setSelectedCalenderFilter(getSelectedCalenderFilter(startDate, endDate))
      if (rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: false, error_message: '' })
      if (currentCalenderActive === 'from') calenderRangeStart?.current?.setSelected(startDate, e); calenderRangeStart?.current?.setPreSelection(startDate);
      if (currentCalenderActive === 'to') calenderRangeEnd?.current?.setSelected(endDate, e); calenderRangeEnd?.current?.setPreSelection(endDate)
    }
  }

  const applyRangeFilter = (sDate, eDate, e, filterName) => {
    setStartDateInputMask(format(new Date(sDate), 'MM-dd-yyyy'))
    setCalenderStartDate(sDate)
    setEndDateInputMask(format(new Date(eDate), 'MM-dd-yyyy'))
    setCalenderEndDate(eDate)
    if (rangeHasErrorObject.has_error) setRangeHasErrorObject({ has_error: false, error_message: '' })
    if (currentCalenderActive === 'from') calenderRangeStart?.current?.setSelected(sDate, e); calenderRangeStart?.current?.setPreSelection(sDate)
    if (currentCalenderActive === 'to') calenderRangeEnd?.current?.setSelected(eDate, e); calenderRangeEnd?.current?.setPreSelection(eDate)
    setSelectedCalenderFilter(filterName)
  }

  const maskProp = {
    hasInputMask: false
  }
  const dateRangeFilterList: any = [
    {
      label: 'Last 1 day',
      action: (e) => {
        let lte = new Date(subDays(new Date(), 1).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 1 day')
        applyRangeFilter(lte, gte, e, 'Last 1 day')
      },
      testId: 'cs-daterange-filter-1'
    },
    {
      label: "Last 7 days",
      action: (e) => {
        let lte = new Date(subDays(new Date(), 6).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 7 days')
        applyRangeFilter(lte, gte, e, 'Last 7 days')
      },
      testId: 'cs-daterange-filter-7'
    },
    {
      label: "Last 14 days",
      action: (e) => {
        let lte = new Date(subDays(new Date(), 13).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 14 days')
        applyRangeFilter(lte, gte, e, 'Last 14 days')
      },
      testId: 'cs-daterange-filter-14'
    },
    {
      label: "Last 30 days",
      action: (e) => {
        let lte = new Date(subDays(new Date(), 29).setHours(0, 0, 0, 0))
        let gte = new Date(new Date().setHours(23, 59, 59, 59))
        // setSelectedCalenderFilter('Last 30 days')
        applyRangeFilter(lte, gte, e, 'Last 30 days')
      },
      testId: 'cs-daterange-filter-30'
    },
    {
      label: "Custom Date",
      action: () => {
        setSelectedCalenderFilter('Custom Date')
      },
      testId: 'cs-daterange-filter-custom'
    }
  ]
  if (customFilterDates) {
    const lastEl: any = dateRangeFilterList.pop()
    customFilterDates.map((filter_el: any) => {
      dateRangeFilterList.push({
        label: `Last ${filter_el} days`,
        action: (e) => {
          let lte = new Date(subDays(new Date(), filter_el - 1).setHours(0, 0, 0, 0))
          let gte = new Date(new Date().setHours(23, 59, 59, 59))
          // setSelectedCalenderFilter('Last 30 days')
          applyRangeFilter(lte, gte, e, `Last ${filter_el} days`)
        },
        testId: `cs-daterange-filter-${filter_el}`
      })
    })
    dateRangeFilterList.push(lastEl)
  }

  return (
    <>
      <div className="DateRangePicker" data-test-id={`cs-daterange-container`}>
        <div className="DateRangePicker__main">
          {withFilters ? <div className="DateRangePicker__left__filters">
            {
              dateRangeFilterList.map((range: any) => {
                return (<div
                  data-test-id={`cs-daterange-filter-${range.testId}`}
                  className={`flex-v-center ${range.label === selectedCalenderFilter ? 'calender-filter-selected' : ''}`}
                  onClick={(e: any) => {
                    // e.stopPropagation();
                    range.action(e)
                  }}>{range.label}</div>)
              })
            }
          </div> : null}
          <div className="DateRangePicker__body">
            <div className="DateRangePicker__header">
              <div className={`DateRangePicker__from__input`}>
                <FieldLabel testId='cs-daterange-label-from' required htmlFor='cs-daterange-from-input' version="v2">From Date</FieldLabel>
                <InputMask
                  onClick={(e: any) => {
                    e.stopPropagation()
                    setcurrentCalenderActive('from')
                  }}
                  disabled={false}
                  data-test-id={'cs-daterange-input-from'}
                  // mask={"99-99-9999"}
                  // maskPlaceholder={"mm-dd-yyyy"}
                  mask={getMaskValue(startDateInputMask)}
                  maskPlaceholder={' '}
                  placeholder={"mm-dd-yyyy"}
                  className={`${classname || ''} ${currentCalenderActive === 'from' ? 'DateRangePicker__input__active' : ''}` || ""}
                  value={(startDateInputMask === '  -  -    ' || startDateInputMask.trim() === '') ? '' : startDateInputMask}
                  onChange={onStartDateInputChangeHandler}
                />
              </div>
              <div className="DateRangePicker__to__input">
                <FieldLabel testId='cs-daterange-label-to' required htmlFor='cs-daterange-to-input' version="v2">To Date</FieldLabel>
                <InputMask
                  onClick={(e: any) => {
                    e.stopPropagation()
                    setcurrentCalenderActive('to')
                  }}
                  className={`${classname || ''} ${currentCalenderActive === 'to' ? 'DateRangePicker__input__active' : ''}` || ""}
                  disabled={false}
                  data-test-id={'cs-daterange-input-to'}
                  // mask={"99-99-9999"}
                  // maskPlaceholder={"mm-dd-yyyy"}
                  mask={getMaskValue(endDateInputMask)}
                  maskPlaceholder={' '}
                  placeholder={"mm-dd-yyyy"}
                  value={(endDateInputMask === '  -  -    ' || endDateInputMask.trim() === '') ? '' : endDateInputMask}
                  onChange={onEndDateInputChangeHandler}
                />
              </div>
              <>{rangeHasErrorObject.has_error &&
                <ValidationMessage testId='cs-daterange-validation-error-message' className='calender__input__error flex-v-center' version='v2' >{rangeHasErrorObject.error_message || 'Please enter valid date'}</ValidationMessage>
              }</>
            </div>
            {
              currentCalenderActive === "from" && (
                <div className="DateRangePicker__from__calender">
                  <Datepicker
                    testId='cs-daterange-from-calender'
                    initialDate={calenderStartDate}
                    version='v2'
                    onChange={onStartDateCalenderChangeHandler}
                    formatType='mm dd yyyy'
                    inputMaskProps={maskProp}
                    withFooter={false}
                    withCurrentDate={false}
                    selectsStart
                    datePickerRestProps={{
                      startDate: calenderStartDate,
                      endDate: calenderEndDate,
                      ref: calenderRangeStart
                    }}
                    enablePropagationOnchange={true}
                  />
                </div>
              )
            }
            {
              currentCalenderActive === "to" && (
                <div className="DateRangePicker__to__calender">
                  <Datepicker
                    testId='cs-daterange-to-calender'
                    initialDate={calenderEndDate}
                    onChange={onEndDateCalenderChangeHandler}
                    startDate={calenderStartDate}
                    endDate={calenderEndDate}
                    version='v2'
                    formatType='mm dd yyyy'
                    inputMaskProps={maskProp}
                    withFooter={false}
                    withCurrentDate={false}
                    selectsEnd
                    datePickerHeadersProps={{
                      maxDate: getMaxDate(new Date()),
                      minDate: calenderStartDate
                    }}
                    datePickerRestProps={{
                      startDate: calenderStartDate,
                      endDate: calenderEndDate,
                      minDate: calenderStartDate,
                      maxDate: getMaxDate(new Date()),
                      ref: calenderRangeEnd
                    }}
                    enablePropagationOnchange={true}
                  />
                </div>
              )
            }
          </div>
        </div>
        {withFooter ? <div className="DateRangePicker__footer flex-justify">
          <Button testId={`${'cs-daterange-calender-reset'}`} buttonType="secondary" size="regular" onClick={onResetClickHandler} version="v2">
            Reset
          </Button>
          <ButtonGroup>
            <Button testId={`${cancelCtaTestId ? cancelCtaTestId : 'cs-daterange-picker-cancel'}`} buttonType="tertiary" onClick={onCancelClickHandler} version="v2">
              Cancel
            </Button>
            <Button testId={`${doneCtaTestId ? doneCtaTestId : 'cs-daterange-picker-done'}`} size="regular" buttonType="primary" version='v2' onClick={onDoneClickHandler} >
              Done
            </Button>
          </ButtonGroup>
        </div> : null}
      </div>
    </>
  )
}